import React, { Component } from 'react';
import axios from "axios";

import { API_URL, ERROR_HANDLE } from "../../../../../config/constants";
import ModalOverlay from "../../../../../components/UI/ModalOverlay";
import theme from '../../../../../Theme/theme';
import SlideSwitch from "../../../../../components/SlideSwitch";

const TITLE = "CANCEL BOOKING";

export default class CancelBooking extends Component {

    state = {
        refund: false
    }

    render () {
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                header={TITLE}
                headerStyle={style.headerStyle}
                headerBodyStyle={style.headerBodyStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                close={this.props.close}>
                <div style={style.label}>
                    Do you wish to cancel this booking?
                </div>
                <div style={style.switchWrapper}>
                    <div style={style.label}>Include Refund</div>
                    <SlideSwitch checked={this.state.refund} onClick={()=>{
                        this.setState({
                            refund: !this.state.refund
                        })
                    }}/>
                </div>
                <div style={style.doneButtonWrapper}>
                    <div style={style.action}
                        onClick={this.save}>
                        Yes
                    </div>
                    <div style={style.action}
                        onClick={this.props.close}>
                        No
                    </div>
                </div>
            </ModalOverlay>
        )
    }

    save = () => {
        const access_token = localStorage.getItem("access_token");
        axios.put(`${API_URL}/trainer/slot/changeUserStatus/${this.props.booking.bookingId}`, {
            status: "CANCELLED",
            refund: this.state.refund
        }, {
            headers: {
                "x-access-token": access_token
            }
        }).then(res => {
            if(res.data.success) {
                this.props.close({
                    bookingStatus: "CANCELLED"
                })
            }
        }).catch(e => {
            ERROR_HANDLE(e)
        })
    }
}

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    headerStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        backgroundColor: theme.color.transparent
    },
    headerBodyStyle: {
        width: "100%",
        height: 40,
        fontSize: 25,
        letterSpacing: 0,
        borderRadius: 3,
        lineHeight: "40px",
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
    },
    modalBody: {
        margin: 25,
        marginTop: 0,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    label: {
        fontFamily: theme.font.avenirBlackOblique,
        color: theme.color.thickGrey,
        marginLeft: 10,
        marginRight: 10
    },
    doneButtonWrapper: {
        width: "400",
        display: "flex",
        justifyContent: "space-around",
        marginTop: 20,
        alignItems: "center"
    },
    switchWrapper: {
        display: "flex",
        flex:1,
        justifyContent: "center",
        alignItems: "center",
        marginTop: 20,
    },
    action: {
        margin:10,
        width: 100,
        alignSelf: 'center',
        backgroundColor: theme.color.teal,
        color: theme.color.white,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 5,
        paddingBottom: 5,
        borderRadius: 5
    }
}